;(() => {
  if (window.griidKlarnaCartV2Initialized) return;
  window.griidKlarnaCartV2Initialized = true;

  const selector = 'griid-klarna-cart';
  const clientId = '90d672cb-7a8a-58bc-b1de-31734eb60870';
  const observedSummaries = new WeakSet();
  let rendererPromise;
  let refreshFrame;

  function ensureRenderer() {
    if (rendererPromise) return rendererPromise;
    rendererPromise = new Promise((resolve, reject) => {
      let script = document.querySelector('script[src*="js.klarna.com/web-sdk/"]');
      const timeout = setTimeout(() => reject(new Error('Klarna renderer did not load.')), 20000);
      customElements.whenDefined('klarna-placement').then(() => {
        clearTimeout(timeout);
        if (!customElements.get(selector)) {
          const KlarnaPlacement = customElements.get('klarna-placement');
          customElements.define(selector, class extends KlarnaPlacement {});
        }
        resolve();
      }).catch(reject);

      if (!script) {
        script = document.createElement('script');
        script.id = 'klarna-osm-script-tag';
        script.src = 'https://js.klarna.com/web-sdk/v1/klarna.js';
        script.async = true;
        script.setAttribute('data-client-id', clientId);
        script.setAttribute('data-environment', 'production');
        script.addEventListener('error', () => {
          clearTimeout(timeout);
          reject(new Error('Klarna script could not be loaded.'));
        }, { once: true });
        document.head.appendChild(script);
      }
    }).catch((error) => {
      rendererPromise = undefined;
      console.warn('[GRIID cart Klarna]', error.message);
      return false;
    });
    return rendererPromise;
  }

  async function refreshDrawer() {
    const drawer = document.querySelector('cart-element[data-view="drawer"]');
    if (!drawer) return;
    const summary = drawer.querySelector('.cart--summary');
    if (summary && !observedSummaries.has(summary)) {
      observedSummaries.add(summary);
      new ResizeObserver(() => {
        if (drawer.isConnected && typeof drawer.updateSummaryHeight === 'function') {
          drawer.updateSummaryHeight();
        }
      }).observe(summary);
    }
    if (!drawer.querySelector(selector)) return;
    const loaded = await ensureRenderer();
    if (loaded === false || !drawer.isConnected || !drawer.querySelector(selector)) return;
    document.dispatchEvent(new CustomEvent('OSM:refresh'));
  }

  function scheduleRefresh() {
    if (refreshFrame) cancelAnimationFrame(refreshFrame);
    refreshFrame = requestAnimationFrame(() => {
      refreshFrame = undefined;
      void refreshDrawer();
    });
  }

  window.addEventListener('theme:cart:updated', (event) => {
    if (event.detail?.dataset?.view === 'drawer') scheduleRefresh();
  });
  window.addEventListener('pageshow', scheduleRefresh);
  document.addEventListener('shopify:section:load', scheduleRefresh);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefresh, { once: true });
  } else {
    scheduleRefresh();
  }
})();
